module.exports = __webpack_public_path__ + "static/pokoj-nr3-photo02-nikon_thumb-ad9ad41de42024c8b43689120a7ad0a2.jpg";